import { render, staticRenderFns } from "./Modernization.vue?vue&type=template&id=eaf5f59e&"
import script from "./Modernization.vue?vue&type=script&lang=js&"
export * from "./Modernization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports